/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { useEffect, type RefObject } from 'react';

export const useOutsideClick = (
  ref: RefObject<HTMLElement | null>,
  callback: () => void,
  excludeSelectors: string[] = [],
) => {
  const handleClick = (e: MouseEvent) => {
    const target = e.target as Node;
    if (!ref.current || ref.current.contains(target)) return;

    if (excludeSelectors.length > 0) {
      const el = target instanceof Element ? target : null;
      if (el && excludeSelectors.some((selector) => el.closest?.(selector))) return;
    }

    callback();
  };

  useEffect(() => {
    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  });
};
